module.exports = __webpack_public_path__ + "img/judgesList.c5531c97.png";